import { render, staticRenderFns } from "./AbouCEO.vue?vue&type=template&id=139a70b6&scoped=true"
import script from "./AbouCEO.vue?vue&type=script&lang=js"
export * from "./AbouCEO.vue?vue&type=script&lang=js"
import style0 from "./AbouCEO.vue?vue&type=style&index=0&id=139a70b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139a70b6",
  null
  
)

export default component.exports